import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@fgb/core';
import { CookieService } from 'ngx-cookie-service';
import { FusionAuthService } from '../fusion-callback-auth.service';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';

const FUSION_SSO_COOKIE = '_fa_sso_upid';

@Component({
  selector: 'fgb-fusion-callback-callback',
  standalone: true,
  imports: [LoadingModule],
  templateUrl: './fusion-callback.component.html',
  styleUrls: ['./fusion-callback.component.scss'],
})
export class FusionCallbackComponent implements OnInit {
  constructor(
    private fusionAuthService: FusionAuthService,
    private router: Router,
    private cookieService: CookieService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      // already logged in
      this.router.navigate(['/']);
    } else if (this.fusionAuthService.hasNamedCookie(FUSION_SSO_COOKIE)) {
      // login through cookies
      let domainCookie = this.getDomainCookie();
      this.authenticateDomainCookie(domainCookie);
    } else {
      // log through a token
      this.authenticateJwt();
    }
  }

  /**
   * make request to authenticate domain
   * cookie if found.
   * If failed then will call authenticate JWT.
   * @param domainCookie domain cookie to
   * be authenticated.
   */
  authenticateDomainCookie(domainCookie: string) {
    this.fusionAuthService
      .loginUsingToken(domainCookie)
      .toPromise()
      .catch(() => {
        this.authenticateJwt();
      });
  }

  /**
   * call to athenticate JWT
   * if failed response will return
   * user to login page.
   */
  authenticateJwt() {
    let jwtToken = this.getProviderJwtToken('code');
    this.fusionAuthService
      .validateJwt(jwtToken)
      .toPromise()
      .catch(() => {
        this.router.navigate(['/login']);
      });
  }

  /**
   * Get a query string parameter without case sensitivity.
   * @param parameter the parameter that you require the information for
   */
  getProviderJwtToken(parameter: string): string {
    const url = window.location.href;
    let paramValue;

    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(parameter);
    }

    if (paramValue) {
      return paramValue;
    }
    return '';
  }

  /**
   * Will check if domain cookie exists
   * and return this as a string.
   * @returns domain cookie from
   * fusion domain
   */
  getDomainCookie(): string {
    let domainCookie = '';
    domainCookie = this.cookieService.get(FUSION_SSO_COOKIE);

    return domainCookie;
  }
}
